import { useState } from "react";
import type { StyleProp, ViewStyle } from "react-native";
import { StyleSheet, View } from "react-native";

import { Button, ButtonProps, useCustomTheme } from "@luna-restaurant/ui";

type SecondaryButtonProps = {
  label: string;
  onPress?: () => void | null | undefined;
  style?: StyleProp<ViewStyle>;
} & Pick<ButtonProps, "iconName" | "iconPosition" | "disabled">;

export const SecondaryButton = ({
  label,
  onPress,
  iconName,
  iconPosition,
  disabled,
  style,
}: SecondaryButtonProps) => {
  const { colors, fonts } = useCustomTheme();
  const [isHovered, setIsHovered] = useState(false);

  const actionColor =
    isHovered && !disabled ? colors.palette.spinach50 : colors.black;

  return (
    <View style={style}>
      <Button
        buttonText={label}
        buttonStyle={[styles.button, { borderColor: actionColor }]}
        buttonTextStyle={[styles.buttonText, fonts.bold]}
        iconName={iconName}
        iconPosition={iconPosition}
        iconSize={24}
        iconColor={actionColor}
        onPress={onPress}
        disabled={disabled}
        onHoverIn={() => setIsHovered(true)}
        onHoverOut={() => setIsHovered(false)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 100,
    borderWidth: 2,
    height: 56,
    paddingVertical: 16,
    paddingHorizontal: 16,
    gap: 8,
  },
  buttonText: {
    fontSize: 16,
    paddingRight: 8,
  },
});
